<div
  *ngIf="isLoading"
  class="flex justify-center align-middle items-center h-90-screen pt-2 px-5"
>
  <h1 class="font-accent font-bold text-xl text-neutral-800">
    {{ 'pay-at-table.payment-confirmation.confirming-payment' | translate }}
  </h1>
</div>
<div *ngIf="!isLoading">
  <!--  Success text -->
  <div class="flex justify-center px-5 pt-7 pb-3 md:w-8/12">
    <p class="text-accent text-2xl md:text-5xl font-bold text-neutral-800 mr-6 md:mr-7 leading-8">
      {{ 'pay-at-table.payment-confirmation.payment-confirmed' | translate }}
    </p>
    <span><i class="icon icon-n-check text-success-600 text-4xl md:text-5.8xl"></i></span>
  </div>

  <!--  Remaining amount to pay -->
  <div
    *ngIf="(outstandingAmount$ | async) > 0"
    class="px-5 pb-3 md:w-8/12"
  >
    <div class="flex flex-col p-5 md:p-6 mb-3 md:mb-8 rounded-m bg-neutral-100 text-center">
      <p class="text-md md:text-29px font-accent font-bold text-neutral-800">
        {{ 'pay-at-table.payment-confirmation.waiting-guests' | translate }}
      </p>
    </div>
  </div>


  <!-- Custom blocks  -->
  <app-block-list [blockIdList]="body"></app-block-list>

  <!-- receive invoice -->
  <div
    *ngIf="transaction"
    class="px-5"
  >
    <app-email-receipt-atom
      [icon]="'icon-receipt_long'"
      [title]="'pay-at-table.payment-confirmation.receipt.receipt-by-email' | translate"
      [text]="'pay-at-table.payment-confirmation.receipt.description' | translate"
      (openModal)="openModalReceipt()"
    ></app-email-receipt-atom>
  </div>
</div>

<app-pat-base-modal *ngIf="!isTransactionCancelled && !isLoading">
  <p class="mb-3 text-neutral-800 text-center font-base">
    {{ 'pay-at-table.overview.left-to-pay' | translate }} :
    <app-price-atom
      [amount]="(outstandingAmount$ | async) || 0"
      [bold]="false"
      [format]="true"
    ></app-price-atom>
  </p>
  <app-button-atom
    class="mx-auto"
    [label]="'pay-at-table.payment-confirmation.back-to-bill' | translate"
    [full]="true"
    (click)="goToOverview()"
  ></app-button-atom>
</app-pat-base-modal>

<app-pat-base-modal *ngIf="isTransactionCancelled">
  <p class="text-accent text-2xl font-bold text-neutral-800 mr-6 mb-3 leading-8">
    {{ 'pay-at-table.payment-confirmation.payment-refused' | translate }}
  </p>
  <p class="mb-3 text-neutral-600 text-center font-base">
    {{ 'pay-at-table.payment-confirmation.payment-refused-desc' | translate }}
  </p>
  <app-button-atom
    class="mx-auto"
    [label]="'pay-at-table.payment-confirmation.continue' | translate"
    [full]="true"
    (click)="goToOverview()"
  ></app-button-atom>
</app-pat-base-modal>
